import PoweredBySvg from "../assets/poweredBy.svg";
import LiveAvatarCustomDemo from "../examples/LiveAvatarExample";

export default function LiveAvatarEmbed() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="pt-[80px] px-[24px] max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="aspect-[16/9] w-full">
            <LiveAvatarCustomDemo />
          </div>
          <div className="flex justify-end p-3">
            <img style={{ width: "107px", height: "34px" }} src={PoweredBySvg} alt="Powered By Curebay" />
          </div>
        </div>
      </div>
    </div>
  );
}